import styled from '@emotion/styled';
import {MainTitleDark as MainTitleDarkUI} from 'ui';
import {colors} from 'ui/config';

export const MainTitleDark = styled(MainTitleDarkUI)({
  marginBottom: 16,
  marginTop: 30,
  fontSize: 26,
});

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: colors.white,
  paddingBottom: 40,
});
